// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"1f074256","312":"b1d0992f","355":"1fd05948","484":"14cb0921","551":"c2ddb01f","672":"477a6254","800":"d79d84e4","842":"01821987","974":"87dcfbc9"}[chunkId] + ".chunk.js";
};